import React from 'react';

import { Divider, Menu, MenuItem, ListItem, ListItemText, Typography } from '@mui/material';

import { logOut } from '@common/contexts/session';
import { track } from '@common/analytics';

const UserMenu = ({
  anchorEl,
  closeMenu,
  isSmall,
  primaryListItemText,
  secondaryListItemText
}) => {
  return (
    <Menu
      id="utility-bar-user-menu"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={closeMenu}
    >
      <MenuItem component={ListItem} disabled sx={{ opacity: '1 !important' }}>
        <ListItemText
          disableTypography
          primary={primaryListItemText}
          secondary={
            <Typography component="div" color="textSecondary" variant="body2">
              {secondaryListItemText}
            </Typography>
          }
        />
      </MenuItem>
      <Divider />
      <MenuItem
        onClick={() => {
          track('navigation', 'edit-profile-intent', 'navigation:app-bar:account-menu');

          window.location =
            '/eduphoria_webcontrols/myinformation.aspx?ReturnUrl=Applications.aspx';
        }}
      >
        Edit Profile
      </MenuItem>
      <MenuItem
        onClick={() => {
          track('navigation', 'logout', 'navigation:app-bar:account-menu');
          logOut();
        }}
      >
        Logout
      </MenuItem>
      {isSmall && [
        <Divider key="divider" />,
        <MenuItem
          key="switch-apps"
          onClick={() => {
            track('navigation', 'logout', 'navigation:app-bar:account-menu');
            logOut();
          }}
        >
          Switch Apps
        </MenuItem>,
        <MenuItem
          key="help"
          onClick={() => {
            track('navigation', 'logout', 'navigation:app-bar:account-menu');
            logOut();
          }}
        >
          Help
        </MenuItem>
      ]}
    </Menu>
  );
};

export default UserMenu;
